import React from "react"
import { withRouter, Link } from "react-router-dom"
import Base from "./Base"
import { Card, Row, Col, Typography, Alert, Progress, message, Spin } from "antd"
import Chart from "react-apexcharts";
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import InvoiceTable from "../../Components/Invoices/InvoiceTable"
import { Auth, API } from "aws-amplify"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"


const { Text } = Typography;
var fecha_actual = new Date();
var mes_actual = fecha_actual.getMonth();
var año_actual = (fecha_actual.getFullYear() - 2000)
var meses = ['Ene-', 'Feb-', 'Mar-', 'Abr-', 'May-', 'Jun-', 'Jul-', 'Ago-', 'Sept-', 'Oct-', 'Nov-', 'Dic-'];

var lastmonth = [mes_actual - 11 >= 0 ? meses[mes_actual - 11] + año_actual : meses[mes_actual + 1] + (año_actual - 1),
mes_actual - 10 >= 0 ? meses[mes_actual - 10] + año_actual : meses[mes_actual + 2] + (año_actual - 1),
mes_actual - 9 >= 0 ? meses[mes_actual - 9] + año_actual : meses[mes_actual + 3] + (año_actual - 1),
mes_actual - 8 >= 0 ? meses[mes_actual - 8] + año_actual : meses[mes_actual + 4] + (año_actual - 1),
mes_actual - 7 >= 0 ? meses[mes_actual - 7] + año_actual : meses[mes_actual + 5] + (año_actual - 1),
mes_actual - 6 >= 0 ? meses[mes_actual - 6] + año_actual : meses[mes_actual + 6] + (año_actual - 1),
mes_actual - 5 >= 0 ? meses[mes_actual - 5] + año_actual : meses[mes_actual + 7] + (año_actual - 1),
mes_actual - 4 >= 0 ? meses[mes_actual - 4] + año_actual : meses[mes_actual + 8] + (año_actual - 1),
mes_actual - 3 >= 0 ? meses[mes_actual - 3] + año_actual : meses[mes_actual + 9] + (año_actual - 1),
mes_actual - 2 >= 0 ? meses[mes_actual - 2] + año_actual : meses[mes_actual + 10] + (año_actual - 1),
mes_actual - 1 >= 0 ? meses[mes_actual - 1] + año_actual : meses[mes_actual + 11] + (año_actual - 1),
meses[mes_actual] + año_actual];


class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.isDeudaAfipCalculated = false;
        this.state = {
            loading: true,
            user: {
            },
            dash_data: {
            },
            deudaAfipLabel: ''
        };
        if(this.props.history.location.state && this.props.history.location.state.data) {
            this.adminLite = this.props.history.location.state.data.adminLite;
        }
    };

    getUser = () => {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/dashboard',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        this.props.UserDataLoad(response['user']);

                        let deudaAfipLabel = <Text style={{ fontSize: '24px', fontWeight: "" }}>
                            {(this.isDeudaAfipCalculated) ? '¡Revisá tu Clave fiscal!' : '¡Calculando!'}
                            </Text>;

                        if (response['user'].deuda_afip !== null) {
                            deudaAfipLabel = (response['user'].deuda_afip === 0) ?
                                <Text style={{ fontSize: '24px', fontWeight: "", color: 'green' }}>¡No tenés deuda!.</Text> :
                                <Text style={{ fontSize: '24px', fontWeight: "", color: 'red' }}>$ {response['user'].deuda_afip}</Text>
                        }

                        this.setState({ deudaAfipLabel, user: response['user'], dash_data: response['dashboard'], loading: false });;
                        if(this.props.login.adminLite){
                            return;
                        }

                        if (response['user'].plan_id === null || response['user'].plan_id === undefined || response['user'].plan === null || response['user'].plan === undefined){
                            if (this.props.location.pathname === '/mp')
                                this.props.history.push('/initial-plan-mp/0')
                            else
                                this.props.history.push('/initial-plan/0')
                        }else if (response['user'].estado_clave_fiscal === 'CREANDO') {
                            if(response['user'].plan === 'Codigo')
                                this.props.history.push('/steps-user/12',{state: { goBackToPayment: false }});
                            else{
                                this.props.history.push('/steps-user/12');
                            }
                        }
                        else if (response['user'].estado_clave_fiscal === 'INACTIVO' || response['user'].estado_clave_fiscal === null) {
                            this.props.history.push('steps-user/0', {state: { goBackToPayment: this.adminLite == null }})
                        }

                    })
                    .catch(err =>{
                        // message.error('Sesion vencida, vuelve a loguearte por favor')
                        // this.props.Logout()
                        // this.props.history.push('/login')
                    })
                })
            .catch(err => {
                message.error('Sesion vencida, vuelve a loguearte por favor')
                this.props.Logout()
                this.props.history.push('/login')
            })
    }

    componentDidMount = async () => {
        this.getUser()
        this.timer()
    }

    timer = () => {
        setTimeout(() => {
            this.isDeudaAfipCalculated = true;
            this.getUser()
        }, 30000)
    }

    componentWillUnmount = () => {
        clearTimeout(this.timer)
    }

    render() {
        if (this.state.loading === true) {
            return (
                <>
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                    <Col style={{minHeight:'360px'}}>
                        <Spin indicator={CustomSpinner}/>
                    </Col>
                </Row>
                <Row></Row>
                </>)
        }
        else {

            let pagoVencido = (this.state.user.estado_pago === 'VENCIDO' || this.state.user.estado_pago === 'INACTIVO') ? true : false
            let pagoEnProceso =(this.state.user.estado_pago ==='PAGO_EN_PROCESO')?true:false
            let pendienteRevision = (this.state.user.estado_monotributo === 'PENDIENTE_REVISION' || this.state.user.estado_monotributo === 'HACER_ALTA') ? true : false
            let usuarioBloqueado = (this.state.user.estado_usuario === 'BLOQUEADO')
            const bajaMonotributo = (this.state.user.estado_monotributo === 'HACER_BAJA' || this.state.user.estado_monotributo === 'CANCELADO' || this.state.user.estado_monotributo === 'EXCLUIDO')
            const warningMonotributo = (!bajaMonotributo && !this.state.user.estado_monotributo === 'ACTIVO')
            let pedidoBaja = (this.state.user.estado_usuario === 'BAJA_PROGRAMADA' || this.state.user.estado_usuario === 'BAJA' || bajaMonotributo) ? true : false
            let claveIncorrecta = (this.state.user.estado_clave_fiscal === 'ERROR_CLAVE_INVALIDA'|| this.state.user.estado_monotributo === 'ERROR_CLAVE_FISCAL_NIVEL_1') ? true : false
            let cargarFotos = (this.state.user.foto_dni_fr === false || this.state.user.foto_dni_tr === false || this.state.user.foto_rostro === false) ? true : false
            
            if (cargarFotos) {
                return (
                    <Base selected='home'>
                        <Alert
                            message='Debés cargar tus fotos'
                            description={<>Para avanzar con tu inscripción, necesitamos que cargues fotos tuyas y de tu DNI. Hacé click <Link to='/micuenta'>acá</Link> para subirlas.</>}
                            type="error"
                            showIcon
                        />
                    </Base>
                )
            } else if (pagoVencido || pedidoBaja) {
                return (
                    <Base selected='home'>
                        <Row>
                            <Alert
                                message='¡Tu Plan ha terminado!'
                                description={<>Para poder usar Liqui, debes renovar tu suscripción. Encontrá el mejor Plan para vos en la sección <Link to='/mejorar-plan'>Mi Plan</Link> </>}
                                type="error"
                                showIcon
                            />
                        </Row>
                    </Base>
                )
            }
            else if (pagoEnProceso) {
                return (
                    <Base selected='home'>
                        <Row>
                            <Alert
                                message='Tu pago no se acreditó'
                                description={<>Estamos esperando la acreditación de tu pago. Una vez que suceda, comenzaremos a trabajar en tu alta. </>}
                                type="error"
                                showIcon
                            />
                        </Row>
                    </Base>
                )
            }else if (pendienteRevision && !claveIncorrecta) {
                return (
                    <Base selected='home'>
                        <Alert
                            message='¡Estamos trabajando en tu alta!'
                            description={<>Estamos trabajando en tu alta. Quedate atento a tu mail. Te notificaremos por allí cuando puedas utilizar Liqui. </>}
                            type="warning"
                            showIcon
                        />
                    </Base>
                )
            }else if (pendienteRevision && claveIncorrecta) {
                return (
                    <Base selected='home'>
                        <Alert
                            message='¡Debes cargar tu clave fiscal!'
                            description={<>Para que puedas usar Liqui, necesitamos tu clave fiscal. Haz click <Link to='/micuenta'>Aquí</Link> para actualizarla.</>}
                            type="warning"
                            showIcon
                        />
                    </Base>
                )
            }
            else if (warningMonotributo) {
                return (
                    <Base selected='home'>
                        <Alert
                            message='¡Estamos trabajando en tu alta!'
                            description={<>Estamos trabajando en tu alta. Quedate atento a tu mail. Te notificaremos por allí cuando puedas utilizar Liqui. </>}
                            type="warning"
                            showIcon
                        />
                    </Base>
                )    
            }
            else if (usuarioBloqueado) {
                return (
                    <Base selected='home'>
                        <Alert
                            message='¡Usuario Bloqueado!'
                            description={<>Tu cuenta ha sido bloqueada. Por favor, comunicate con nosotros para poder seguir utilizando la plataforma.</>}
                            type="error"
                            showIcon
                        />
                    </Base>
                )
            } /*if (this.state.loading === false) {
                this.state.user.acumulacion_semestral = null;
                if (mes_actual > 5) {
                    for (var i = 11 - mes_actual; i < 12; i++) {
                        this.state.user.acumulacion_semestral += parseInt(this.state.dash_data.facturacion[i]);
                    }
                }
                else {
                    for (i = 5 - mes_actual; i < 12; i++) {
                        this.state.user.acumulacion_semestral += parseInt(this.state.dash_data.facturacion[i]);
                    }
                }
            }*/

            let options = {
                chart: {
                    id: "Facturacion"
                },
                xaxis: {
                    type: 'time',
                    time: {
                        unit: 'Month'
                    },
                    categories: lastmonth   
                },
                colors: ['#353FDF', '#49ECAD'],
                stroke: {
                    width: [0, 3]
                },
                markers: {
                    size: [0, 4]
                }
            }
            let roundData= this.state.dash_data.facturacion_hist.map(value =>{
                return value.toFixed(2)
            })
            let series = [
                {
                    type: 'column',
                    name: "Facturacion",
                    data: roundData
                },
            ]

            return (

                <Base
                    selected="home"
                >
                    { claveIncorrecta ? <Alert
                        message='Debés cargar tu clave fiscal'
                        description={<>Para que puedas usar Liqui, necesitamos tu clave fiscal. Haz click <Link to='/micuenta'>Aquí</Link> para actualizarla.</>}
                        type="error"
                        showIcon
                        closable
                        style={{ marginBottom: '10px' }}
                    /> : null}
                    <Row gutter={[8, 12]}>
                        <Col lg={6}>
                            <Card
                                title="Categoría Monotributo"
                                bodyStyle={{ width: "100%", textAlign: "center" }}>
                                <Text style={{ fontSize: '24px' }}>{this.state.dash_data.monotributo_categoria} </Text>
                            </Card>
                        </Col>

                        <Col lg={6}>
                            <Card
                                title="Cuota Mensual Monotributo"
                                bodyStyle={{ width: "100%", textAlign: "center" }}>
                                <Text style={{ fontSize: '24px', fontWeight: "" }}> ${(this.state.dash_data.cuota_actividad + this.state.dash_data.cuota_os + this.state.dash_data.cuota_sipa).toLocaleString()}</Text>
                            </Card>
                        </Col>

                        <Col lg={6}>
                            <Card
                                title="Proximo Vencimiento"
                                bodyStyle={{ width: "100%", textAlign: "center" }}>
                                <Text style={{ fontSize: '24px', fontWeight: "" }}>{this.state.dash_data.monotributo_vto}</Text>
                            </Card>
                        </Col>
                        <Col lg={6}>
                            <Card
                                title="Deuda con AFIP"
                                bodyStyle={{ width: "100%", textAlign: "center" }}>
                                {this.state.deudaAfipLabel}
                            </Card>
                        </Col>
                    </Row>

                    <Row gutter={[8, 12]} type="flex">
                        <Col lg={12} xs={24}>
                            <Card title="Facturación acumulada" lg={12} style={{ height: '100%' }}>
                                <Row style={{ textAlign: "center" }}>
                                    <Progress type="circle" width={100} percent={Math.round((this.state.dash_data.facturacion_acumulada / this.state.dash_data.monotributo_maximo) * 100)} strokeColor="#353FDF" />
                                    <br />
                                    <Text> Desde {mes_actual > 5 ? 'Enero' : 'Julio'} hasta hoy</Text>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={6} xs={24}>
                            <Card title="Facturación acumulada" lg={12} style={{ height: '100%' }}>
                                <Row style={{ textAlign: "center" }}>
                                    
                                    <br />
                                    <Text style={{ fontSize: '24px' }}> $ {(this.state.dash_data.facturacion_acumulada).toLocaleString()} </Text>
                                    <br />
                                    <br />
                                    <br />
                                    <Text > Desde {mes_actual > 5 ? 'Enero' : 'Julio'} hasta hoy</Text>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={6} xs={24}>
                            <Card title="Saldo para facturar" lg={12} style={{ height: '100%' }}>
                                <Row style={{ textAlign: "center" }}>
                                <br />
                                    <Text style={{ fontSize: '24px' }}>
                                        $ {((this.state.dash_data.monotributo_maximo - this.state.dash_data.facturacion_acumulada) > 0 ? this.state.dash_data.monotributo_maximo - this.state.dash_data.facturacion_acumulada : "0"  ).toLocaleString()}
                                    </Text>
                                    <br />
                                    <br />
                                    <br />
                                    <Text> Hasta {mes_actual > 5 ? 'Diciembre' : 'Junio'} sin cambiarte de categoria </Text>
                                </Row>
                            </Card>
                        </Col>
                    </Row>

                    <Row gutter={[8, 12]} style={{ marginTop: '6px' }}>
                        <Col>
                            <Card
                                xs={24}
                                title={"Evolución de facturación en Liqui (Últimos 12 meses)"}
                                style={{ textAlign: 'center' }}
                            >
                                {
                                    this.state.loading ?
                                        <Spin></Spin>
                                        :
                                        <Chart
                                            options={options}
                                            series={series}
                                            height='320px'
                                            width="90%"
                                        />
                                }
                            </Card>
                        </Col>
                        <Col >
                            <Card title="Ultimas Facturas" bodyStyle={{ width: "100%" }}>
                                <InvoiceTable
                                    dashboard={true}
                                />
                            </Card>
                        </Col>
                    </Row>


                </Base>

            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));
